"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var console_1 = require("../../../../reducers/slices/console");
var branch_manager_1 = require("./branch_manager");
var business_details_1 = require("./business_details");
var email_notification_1 = require("./email_notification");
var order_manager_1 = require("./order_manager");
var package_details_1 = require("./package_details");
var stock_management_1 = require("./stock_management");
var stock_replacement_1 = require("./stock_replacement");
var supplier_1 = require("./supplier");
var tokens_manager_1 = require("./tokens_manager");
var SettingsPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Account Settings"));
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col gap-4" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-2 gap-4" }, { children: [(0, jsx_runtime_1.jsx)(business_details_1.BusinessDetails, {}), (0, jsx_runtime_1.jsx)(package_details_1.PackageDetails, {})] })), (0, jsx_runtime_1.jsx)(stock_replacement_1.StockReplacement, {}), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-2 gap-4" }, { children: [(0, jsx_runtime_1.jsx)(email_notification_1.EmailNotification, {}), (0, jsx_runtime_1.jsx)(stock_management_1.StockManagement, {})] })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "grid grid-cols-2 gap-4 mb-4" }, { children: [(0, jsx_runtime_1.jsx)(branch_manager_1.BranchManager, {}), (0, jsx_runtime_1.jsx)(supplier_1.SupplierComponent, {}), (0, jsx_runtime_1.jsx)(order_manager_1.OrderManager, {}), (0, jsx_runtime_1.jsx)(tokens_manager_1.TokensComponent, {})] }))] })));
};
exports.SettingsPage = SettingsPage;
